module.exports = __webpack_public_path__ + "img/icon-ship.4e5688a0.svg";